import FileBrowserApi from '../../../services/api/file-browser';

export async function getOrCreateRootFolderId(name) {
    const { data } = await FileBrowserApi.checkRootFolderExists(name);
    if (data.exists) {
        return data.folder.id;
    }
    const { data: folder } = await FileBrowserApi.createFolderByName('/file/create_folder_by_name', { parent_id: null, name });

    return folder.id;
}
